import * as Mod1 from "./discourse/adapters/chat-message";
import * as Mod2 from "./discourse/admin-chat-route-map";
import * as Mod3 from "./discourse/chat-route-map";
import * as Mod4 from "./discourse/components/browse-channels";
import * as Mod5 from "./discourse/components/channel-icon/index";
import * as Mod6 from "./discourse/components/channel-name/index";
import * as Mod7 from "./discourse/components/channel-title/index";
import * as Mod8 from "./discourse/components/channels-list-direct";
import * as Mod9 from "./discourse/components/channels-list-public";
import * as Mod10 from "./discourse/components/channels-list-starred";
import * as Mod11 from "./discourse/components/channels-list";
import * as Mod12 from "./discourse/components/chat-channel-archive-status";
import * as Mod13 from "./discourse/components/chat-channel-card";
import * as Mod14 from "./discourse/components/chat-channel-chooser-header";
import * as Mod15 from "./discourse/components/chat-channel-chooser-row";
import * as Mod16 from "./discourse/components/chat-channel-chooser";
import * as Mod17 from "./discourse/components/chat-channel-filter";
import * as Mod18 from "./discourse/components/chat-channel-leave-btn";
import * as Mod19 from "./discourse/components/chat-channel-list-filter-menu";
import * as Mod20 from "./discourse/components/chat-channel-list-filter-toggle";
import * as Mod21 from "./discourse/components/chat-channel-list-options-button";
import * as Mod22 from "./discourse/components/chat-channel-list-sidebar-menu";
import * as Mod23 from "./discourse/components/chat-channel-list-sort-choice";
import * as Mod24 from "./discourse/components/chat-channel-list-sort-menu";
import * as Mod25 from "./discourse/components/chat-channel-metadata";
import * as Mod26 from "./discourse/components/chat-channel-preview-card";
import * as Mod27 from "./discourse/components/chat-channel-row";
import * as Mod28 from "./discourse/components/chat-channel-sidebar-context-menu";
import * as Mod29 from "./discourse/components/chat-channel-sidebar-context-notification-submenu";
import * as Mod30 from "./discourse/components/chat-channel-status";
import * as Mod31 from "./discourse/components/chat-channel-title";
import * as Mod32 from "./discourse/components/chat-channel-unread-indicator";
import * as Mod33 from "./discourse/components/chat-channel";
import * as Mod34 from "./discourse/components/chat-composer-dropdown";
import * as Mod35 from "./discourse/components/chat-composer-message-details";
import * as Mod36 from "./discourse/components/chat-composer-upload";
import * as Mod37 from "./discourse/components/chat-composer-uploads";
import * as Mod38 from "./discourse/components/chat-composer";
import * as Mod39 from "./discourse/components/chat-drawer";
import * as Mod40 from "./discourse/components/chat-emoji-avatar";
import * as Mod41 from "./discourse/components/chat-footer";
import * as Mod42 from "./discourse/components/chat-header";
import * as Mod43 from "./discourse/components/chat-mention-warnings";
import * as Mod44 from "./discourse/components/chat-message-actions-desktop";
import * as Mod45 from "./discourse/components/chat-message-actions-mobile";
import * as Mod46 from "./discourse/components/chat-message-collapser";
import * as Mod47 from "./discourse/components/chat-message-in-reply-to-indicator";
import * as Mod48 from "./discourse/components/chat-message-reaction";
import * as Mod49 from "./discourse/components/chat-message-reactions-users";
import * as Mod50 from "./discourse/components/chat-message-separator";
import * as Mod51 from "./discourse/components/chat-message-text";
import * as Mod52 from "./discourse/components/chat-message-thread-indicator";
import * as Mod53 from "./discourse/components/chat-message";
import * as Mod54 from "./discourse/components/chat-message/blocks/actions";
import * as Mod55 from "./discourse/components/chat-message/blocks/block";
import * as Mod56 from "./discourse/components/chat-message/blocks/confirmation";
import * as Mod57 from "./discourse/components/chat-message/blocks/element";
import * as Mod58 from "./discourse/components/chat-message/blocks/elements/button";
import * as Mod59 from "./discourse/components/chat-message/blocks/elements/category";
import * as Mod60 from "./discourse/components/chat-message/blocks/index";
import * as Mod61 from "./discourse/components/chat-message/blocks/informative";
import * as Mod62 from "./discourse/components/chat-messages-container";
import * as Mod63 from "./discourse/components/chat-messages-scroller";
import * as Mod64 from "./discourse/components/chat-notice";
import * as Mod65 from "./discourse/components/chat-notices";
import * as Mod66 from "./discourse/components/chat-pinned-messages-list";
import * as Mod67 from "./discourse/components/chat-replying-indicator";
import * as Mod68 from "./discourse/components/chat-retention-reminder-text";
import * as Mod69 from "./discourse/components/chat-retention-reminder";
import * as Mod70 from "./discourse/components/chat-search";
import * as Mod71 from "./discourse/components/chat-side-panel-resizer";
import * as Mod72 from "./discourse/components/chat-side-panel";
import * as Mod73 from "./discourse/components/chat-sidebar-channel-list-filter-empty-state";
import * as Mod74 from "./discourse/components/chat-sidebar-indicators";
import * as Mod75 from "./discourse/components/chat-skeleton";
import * as Mod76 from "./discourse/components/chat-thread-heading";
import * as Mod77 from "./discourse/components/chat-thread-list";
import * as Mod78 from "./discourse/components/chat-thread-participants";
import * as Mod79 from "./discourse/components/chat-thread-title-prompt";
import * as Mod80 from "./discourse/components/chat-thread";
import * as Mod81 from "./discourse/components/chat-to-topic-selector";
import * as Mod82 from "./discourse/components/chat-upload-drop-zone";
import * as Mod83 from "./discourse/components/chat-upload";
import * as Mod84 from "./discourse/components/chat-user-avatar";
import * as Mod85 from "./discourse/components/chat-user-display-name";
import * as Mod86 from "./discourse/components/chat-user-info";
import * as Mod87 from "./discourse/components/chat/channel/empty-state";
import * as Mod88 from "./discourse/components/chat/composer/button";
import * as Mod89 from "./discourse/components/chat/composer/channel";
import * as Mod90 from "./discourse/components/chat/composer/separator";
import * as Mod91 from "./discourse/components/chat/composer/thread";
import * as Mod92 from "./discourse/components/chat/direct-message-button";
import * as Mod93 from "./discourse/components/chat/disabled";
import * as Mod94 from "./discourse/components/chat/drawer-routes/browse";
import * as Mod95 from "./discourse/components/chat/drawer-routes/channel-info-members";
import * as Mod96 from "./discourse/components/chat/drawer-routes/channel-info-settings";
import * as Mod97 from "./discourse/components/chat/drawer-routes/channel-pins";
import * as Mod98 from "./discourse/components/chat/drawer-routes/channel-thread";
import * as Mod99 from "./discourse/components/chat/drawer-routes/channel-threads";
import * as Mod100 from "./discourse/components/chat/drawer-routes/channel";
import * as Mod101 from "./discourse/components/chat/drawer-routes/channels";
import * as Mod102 from "./discourse/components/chat/drawer-routes/direct-messages";
import * as Mod103 from "./discourse/components/chat/drawer-routes/search";
import * as Mod104 from "./discourse/components/chat/drawer-routes/starred-channels";
import * as Mod105 from "./discourse/components/chat/drawer-routes/threads";
import * as Mod106 from "./discourse/components/chat/footer/unread-indicator";
import * as Mod107 from "./discourse/components/chat/form";
import * as Mod108 from "./discourse/components/chat/form/row";
import * as Mod109 from "./discourse/components/chat/form/section";
import * as Mod110 from "./discourse/components/chat/header/icon";
import * as Mod111 from "./discourse/components/chat/header/icon/unread-indicator";
import * as Mod112 from "./discourse/components/chat/list/empty-state";
import * as Mod113 from "./discourse/components/chat/list/index";
import * as Mod114 from "./discourse/components/chat/list/item";
import * as Mod115 from "./discourse/components/chat/message-creator/add-members";
import * as Mod116 from "./discourse/components/chat/message-creator/channel";
import * as Mod117 from "./discourse/components/chat/message-creator/constants";
import * as Mod118 from "./discourse/components/chat/message-creator/group";
import * as Mod119 from "./discourse/components/chat/message-creator/index";
import * as Mod120 from "./discourse/components/chat/message-creator/lib/chatables-loader";
import * as Mod121 from "./discourse/components/chat/message-creator/lib/iterate-list";
import * as Mod122 from "./discourse/components/chat/message-creator/list-action";
import * as Mod123 from "./discourse/components/chat/message-creator/list-handler";
import * as Mod124 from "./discourse/components/chat/message-creator/list";
import * as Mod125 from "./discourse/components/chat/message-creator/member";
import * as Mod126 from "./discourse/components/chat/message-creator/members-count";
import * as Mod127 from "./discourse/components/chat/message-creator/members-selector";
import * as Mod128 from "./discourse/components/chat/message-creator/members";
import * as Mod129 from "./discourse/components/chat/message-creator/new-group";
import * as Mod130 from "./discourse/components/chat/message-creator/search-input";
import * as Mod131 from "./discourse/components/chat/message-creator/search";
import * as Mod132 from "./discourse/components/chat/message-creator/user";
import * as Mod133 from "./discourse/components/chat/message/avatar";
import * as Mod134 from "./discourse/components/chat/message/error";
import * as Mod135 from "./discourse/components/chat/message/info";
import * as Mod136 from "./discourse/components/chat/message/left-gutter";
import * as Mod137 from "./discourse/components/chat/modal/archive-channel";
import * as Mod138 from "./discourse/components/chat/modal/create-channel";
import * as Mod139 from "./discourse/components/chat/modal/delete-channel";
import * as Mod140 from "./discourse/components/chat/modal/delete-messages-confirm";
import * as Mod141 from "./discourse/components/chat/modal/edit-channel-description";
import * as Mod142 from "./discourse/components/chat/modal/edit-channel-name";
import * as Mod143 from "./discourse/components/chat/modal/move-message-to-channel";
import * as Mod144 from "./discourse/components/chat/modal/new-message";
import * as Mod145 from "./discourse/components/chat/modal/thread-settings";
import * as Mod146 from "./discourse/components/chat/modal/toggle-channel-status";
import * as Mod147 from "./discourse/components/chat/navbar/actions";
import * as Mod148 from "./discourse/components/chat/navbar/back-button";
import * as Mod149 from "./discourse/components/chat/navbar/channel-list-options-button";
import * as Mod150 from "./discourse/components/chat/navbar/channel-title";
import * as Mod151 from "./discourse/components/chat/navbar/close-drawer-button";
import * as Mod152 from "./discourse/components/chat/navbar/close-pins-button";
import * as Mod153 from "./discourse/components/chat/navbar/close-thread-button";
import * as Mod154 from "./discourse/components/chat/navbar/close-threads-button";
import * as Mod155 from "./discourse/components/chat/navbar/filter";
import * as Mod156 from "./discourse/components/chat/navbar/full-page-button";
import * as Mod157 from "./discourse/components/chat/navbar/index";
import * as Mod158 from "./discourse/components/chat/navbar/new-channel-button";
import * as Mod159 from "./discourse/components/chat/navbar/open-drawer-button";
import * as Mod160 from "./discourse/components/chat/navbar/pinned-messages-button";
import * as Mod161 from "./discourse/components/chat/navbar/sub-title";
import * as Mod162 from "./discourse/components/chat/navbar/thread-settings-button";
import * as Mod163 from "./discourse/components/chat/navbar/thread-tracking-dropdown";
import * as Mod164 from "./discourse/components/chat/navbar/threads-list-button";
import * as Mod165 from "./discourse/components/chat/navbar/title";
import * as Mod166 from "./discourse/components/chat/navbar/toggle-drawer-button";
import * as Mod167 from "./discourse/components/chat/notices/mention_without_membership";
import * as Mod168 from "./discourse/components/chat/pinned-message-bar";
import * as Mod169 from "./discourse/components/chat/pinned-messages-list/header";
import * as Mod170 from "./discourse/components/chat/routes/channel-info-members";
import * as Mod171 from "./discourse/components/chat/routes/channel-info-nav";
import * as Mod172 from "./discourse/components/chat/routes/channel-info-settings";
import * as Mod173 from "./discourse/components/chat/routes/channel-info";
import * as Mod174 from "./discourse/components/chat/routes/channel-pins";
import * as Mod175 from "./discourse/components/chat/routes/channel-thread";
import * as Mod176 from "./discourse/components/chat/routes/channel-threads";
import * as Mod177 from "./discourse/components/chat/routes/channel";
import * as Mod178 from "./discourse/components/chat/routes/channels";
import * as Mod179 from "./discourse/components/chat/routes/direct-messages";
import * as Mod180 from "./discourse/components/chat/routes/search";
import * as Mod181 from "./discourse/components/chat/routes/starred-channels";
import * as Mod182 from "./discourse/components/chat/routes/threads";
import * as Mod183 from "./discourse/components/chat/scroll-to-bottom-arrow";
import * as Mod184 from "./discourse/components/chat/selection-manager";
import * as Mod185 from "./discourse/components/chat/thread-list/header";
import * as Mod186 from "./discourse/components/chat/thread-list/item";
import * as Mod187 from "./discourse/components/chat/thread/header-unread-indicator";
import * as Mod188 from "./discourse/components/chat/thread/header";
import * as Mod189 from "./discourse/components/collapser";
import * as Mod190 from "./discourse/components/full-page-chat";
import * as Mod191 from "./discourse/components/reviewable/chat-message";
import * as Mod192 from "./discourse/components/styleguide/chat-composer-message-details";
import * as Mod193 from "./discourse/components/styleguide/chat-composer";
import * as Mod194 from "./discourse/components/styleguide/chat-header-icon";
import * as Mod195 from "./discourse/components/styleguide/chat-message";
import * as Mod196 from "./discourse/components/styleguide/chat-modal-archive-channel";
import * as Mod197 from "./discourse/components/styleguide/chat-modal-create-channel";
import * as Mod198 from "./discourse/components/styleguide/chat-modal-delete-channel";
import * as Mod199 from "./discourse/components/styleguide/chat-modal-edit-channel-description";
import * as Mod200 from "./discourse/components/styleguide/chat-modal-edit-channel-name";
import * as Mod201 from "./discourse/components/styleguide/chat-modal-move-message-to-channel";
import * as Mod202 from "./discourse/components/styleguide/chat-modal-new-message";
import * as Mod203 from "./discourse/components/styleguide/chat-modal-thread-settings";
import * as Mod204 from "./discourse/components/styleguide/chat-modal-toggle-channel-status";
import * as Mod205 from "./discourse/components/styleguide/chat-thread-list-item";
import * as Mod206 from "./discourse/components/styleguide/organisms/chat";
import * as Mod207 from "./discourse/components/svg/chat-zero";
import * as Mod208 from "./discourse/components/thread-notifications-tracking";
import * as Mod209 from "./discourse/components/thread-title/index";
import * as Mod210 from "./discourse/components/thread-unread-indicator/index";
import * as Mod211 from "./discourse/components/toggle-channel-membership-button";
import * as Mod212 from "./discourse/components/upsert-category/chat";
import * as Mod213 from "./discourse/components/user-menu/chat-notifications-list-empty-state";
import * as Mod214 from "./discourse/components/user-menu/chat-notifications-list";
import * as Mod215 from "./discourse/components/user-threads/index";
import * as Mod216 from "./discourse/components/user-threads/preview";
import * as Mod217 from "./discourse/connectors/above-site-header/chat-body-class.gjs";
import * as Mod218 from "./discourse/connectors/below-footer/chat-drawer-outlet.gjs";
import * as Mod219 from "./discourse/connectors/chat-composer-inline-buttons/emoji-picker.gjs";
import * as Mod220 from "./discourse/connectors/home-logo-wrapper/chat-header-connector.gjs";
import * as Mod221 from "./discourse/connectors/user-card-below-message-button/chat-button.gjs";
import * as Mod222 from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-chat-emails.gjs";
import * as Mod223 from "./discourse/connectors/user-preferences-nav/chat-preferences.gjs";
import * as Mod224 from "./discourse/connectors/user-preferences-notifications/chat-notifications.gjs";
import * as Mod225 from "./discourse/connectors/user-profile-controls/chat-button.gjs";
import * as Mod226 from "./discourse/controllers/chat-draft-channel";
import * as Mod227 from "./discourse/controllers/chat";
import * as Mod228 from "./discourse/controllers/chat/channel";
import * as Mod229 from "./discourse/controllers/chat/channel/index";
import * as Mod230 from "./discourse/controllers/chat/channel/thread";
import * as Mod231 from "./discourse/controllers/chat/index";
import * as Mod232 from "./discourse/controllers/chat/new-message";
import * as Mod233 from "./discourse/helpers/chat-guardian";
import * as Mod234 from "./discourse/helpers/first-visible-message-id";
import * as Mod235 from "./discourse/helpers/format-chat-date";
import * as Mod236 from "./discourse/initializers/chat-audio";
import * as Mod237 from "./discourse/initializers/chat-category-tab";
import * as Mod238 from "./discourse/initializers/chat-decorators";
import * as Mod239 from "./discourse/initializers/chat-keyboard-shortcuts";
import * as Mod240 from "./discourse/initializers/chat-plugin-decorators";
import * as Mod241 from "./discourse/initializers/chat-setup";
import * as Mod242 from "./discourse/initializers/chat-sidebar";
import * as Mod243 from "./discourse/initializers/chat-user-menu";
import * as Mod244 from "./discourse/initializers/chat-user-options";
import * as Mod245 from "./discourse/lib/chat-alert-dedup";
import * as Mod246 from "./discourse/lib/chat-channel-list-options";
import * as Mod247 from "./discourse/lib/chat-channel-subscription-manager";
import * as Mod248 from "./discourse/lib/chat-channel-thread-subscription-manager";
import * as Mod249 from "./discourse/lib/chat-composer-buttons";
import * as Mod250 from "./discourse/lib/chat-constants";
import * as Mod251 from "./discourse/lib/chat-message-announcement";
import * as Mod252 from "./discourse/lib/chat-message-container";
import * as Mod253 from "./discourse/lib/chat-message-flag";
import * as Mod254 from "./discourse/lib/chat-message-interactor";
import * as Mod255 from "./discourse/lib/chat-messages-loader";
import * as Mod256 from "./discourse/lib/chat-messages-manager";
import * as Mod257 from "./discourse/lib/chat-notification-levels";
import * as Mod258 from "./discourse/lib/chat-pane-state";
import * as Mod259 from "./discourse/lib/chat-pinned-bar-dismissal";
import * as Mod260 from "./discourse/lib/chat-threads-manager";
import * as Mod261 from "./discourse/lib/chat-user-preferences";
import * as Mod262 from "./discourse/lib/check-message-visibility";
import * as Mod263 from "./discourse/lib/collection";
import * as Mod264 from "./discourse/lib/dates-separators-positioner";
import * as Mod265 from "./discourse/lib/extract-current-topic-info";
import * as Mod266 from "./discourse/lib/fabricators";
import * as Mod267 from "./discourse/lib/get-reaction-text";
import * as Mod268 from "./discourse/lib/get-user-chat-separate-sidebar-mode";
import * as Mod269 from "./discourse/lib/gif-pick-handler";
import * as Mod270 from "./discourse/lib/group-chat-transcripts";
import * as Mod271 from "./discourse/lib/hashtag-types/channel";
import * as Mod272 from "./discourse/lib/init-sidebar-state";
import * as Mod273 from "./discourse/lib/scroll-helpers";
import * as Mod274 from "./discourse/lib/slugify-channel";
import * as Mod275 from "./discourse/lib/textarea-interactor";
import * as Mod276 from "./discourse/lib/transcript-source-types";
import * as Mod277 from "./discourse/lib/transform-auto-links";
import * as Mod278 from "./discourse/models/chat-channel-archive";
import * as Mod279 from "./discourse/models/chat-channel";
import * as Mod280 from "./discourse/models/chat-chatable";
import * as Mod281 from "./discourse/models/chat-direct-message";
import * as Mod282 from "./discourse/models/chat-message-reaction";
import * as Mod283 from "./discourse/models/chat-message";
import * as Mod284 from "./discourse/models/chat-notice";
import * as Mod285 from "./discourse/models/chat-thread-preview";
import * as Mod286 from "./discourse/models/chat-thread";
import * as Mod287 from "./discourse/models/chat-tracking-state";
import * as Mod288 from "./discourse/models/user-chat-channel-membership";
import * as Mod289 from "./discourse/models/user-chat-thread-membership";
import * as Mod290 from "./discourse/modifiers/chat/later-fn";
import * as Mod291 from "./discourse/modifiers/chat/on-animation-end";
import * as Mod292 from "./discourse/modifiers/chat/on-long-press";
import * as Mod293 from "./discourse/modifiers/chat/on-scroll";
import * as Mod294 from "./discourse/modifiers/chat/resizable-node";
import * as Mod295 from "./discourse/modifiers/chat/scrollable-list";
import * as Mod296 from "./discourse/modifiers/chat/track-message-separator-date";
import * as Mod297 from "./discourse/modifiers/chat/track-message";
import * as Mod298 from "./discourse/pre-initializers/chat-plugin-api";
import * as Mod299 from "./discourse/pre-initializers/chat-transformers";
import * as Mod300 from "./discourse/preferences-chat-route-map";
import * as Mod301 from "./discourse/routes/chat-channel-decorator";
import * as Mod302 from "./discourse/routes/chat-channel-legacy";
import * as Mod303 from "./discourse/routes/chat-draft-channel";
import * as Mod304 from "./discourse/routes/chat";
import * as Mod305 from "./discourse/routes/chat/browse";
import * as Mod306 from "./discourse/routes/chat/browse/archived";
import * as Mod307 from "./discourse/routes/chat/browse/index";
import * as Mod308 from "./discourse/routes/chat/channel";
import * as Mod309 from "./discourse/routes/chat/channel/info";
import * as Mod310 from "./discourse/routes/chat/channel/info/index";
import * as Mod311 from "./discourse/routes/chat/channel/info/members";
import * as Mod312 from "./discourse/routes/chat/channel/info/search";
import * as Mod313 from "./discourse/routes/chat/channel/near-message-with-thread";
import * as Mod314 from "./discourse/routes/chat/channel/near-message";
import * as Mod315 from "./discourse/routes/chat/channel/pins";
import * as Mod316 from "./discourse/routes/chat/channel/thread";
import * as Mod317 from "./discourse/routes/chat/channel/thread/near-message";
import * as Mod318 from "./discourse/routes/chat/channel/threads";
import * as Mod319 from "./discourse/routes/chat/channels";
import * as Mod320 from "./discourse/routes/chat/direct-messages";
import * as Mod321 from "./discourse/routes/chat/disabled";
import * as Mod322 from "./discourse/routes/chat/index";
import * as Mod323 from "./discourse/routes/chat/new-message";
import * as Mod324 from "./discourse/routes/chat/search";
import * as Mod325 from "./discourse/routes/chat/starred-channels";
import * as Mod326 from "./discourse/routes/chat/threads";
import * as Mod327 from "./discourse/routes/preferences/chat";
import * as Mod328 from "./discourse/services/chat-admin-api";
import * as Mod329 from "./discourse/services/chat-api";
import * as Mod330 from "./discourse/services/chat-audio-manager";
import * as Mod331 from "./discourse/services/chat-channel-composer";
import * as Mod332 from "./discourse/services/chat-channel-info-route-origin-manager";
import * as Mod333 from "./discourse/services/chat-channel-list-preferences";
import * as Mod334 from "./discourse/services/chat-channel-notices-manager";
import * as Mod335 from "./discourse/services/chat-channel-pane";
import * as Mod336 from "./discourse/services/chat-channel-scroll-positions";
import * as Mod337 from "./discourse/services/chat-channels-manager";
import * as Mod338 from "./discourse/services/chat-composer-warnings-tracker";
import * as Mod339 from "./discourse/services/chat-drafts-manager";
import * as Mod340 from "./discourse/services/chat-drawer-router";
import * as Mod341 from "./discourse/services/chat-drawer-size";
import * as Mod342 from "./discourse/services/chat-guardian";
import * as Mod343 from "./discourse/services/chat-history";
import * as Mod344 from "./discourse/services/chat-new-message-announcer";
import * as Mod345 from "./discourse/services/chat-notification-manager";
import * as Mod346 from "./discourse/services/chat-pane-pending-manager";
import * as Mod347 from "./discourse/services/chat-search-query";
import * as Mod348 from "./discourse/services/chat-state-manager";
import * as Mod349 from "./discourse/services/chat-subscriptions-manager";
import * as Mod350 from "./discourse/services/chat-thread-composer";
import * as Mod351 from "./discourse/services/chat-thread-list-pane";
import * as Mod352 from "./discourse/services/chat-thread-pane";
import * as Mod353 from "./discourse/services/chat-tracking-state-manager";
import * as Mod354 from "./discourse/services/chat";
import * as Mod355 from "./discourse/services/interacted-chat-message";
import * as Mod356 from "./discourse/templates/chat";
import * as Mod357 from "./discourse/templates/chat/browse";
import * as Mod358 from "./discourse/templates/chat/browse/all";
import * as Mod359 from "./discourse/templates/chat/browse/archived";
import * as Mod360 from "./discourse/templates/chat/browse/closed";
import * as Mod361 from "./discourse/templates/chat/browse/open";
import * as Mod362 from "./discourse/templates/chat/channel";
import * as Mod363 from "./discourse/templates/chat/channel/info";
import * as Mod364 from "./discourse/templates/chat/channel/info/members";
import * as Mod365 from "./discourse/templates/chat/channel/info/settings";
import * as Mod366 from "./discourse/templates/chat/channel/pins";
import * as Mod367 from "./discourse/templates/chat/channel/thread";
import * as Mod368 from "./discourse/templates/chat/channel/threads";
import * as Mod369 from "./discourse/templates/chat/channels";
import * as Mod370 from "./discourse/templates/chat/direct-messages";
import * as Mod371 from "./discourse/templates/chat/disabled";
import * as Mod372 from "./discourse/templates/chat/index";
import * as Mod373 from "./discourse/templates/chat/search";
import * as Mod374 from "./discourse/templates/chat/starred-channels";
import * as Mod375 from "./discourse/templates/chat/threads";
import * as Mod376 from "./discourse/templates/preferences/chat";
import * as Mod377 from "./lib/discourse-markdown/chat-html-inline";
import * as Mod378 from "./lib/discourse-markdown/chat-transcript";
import * as Mod379 from "./lib/rich-editor-extension";
const compatModules = {
  "discourse/adapters/chat-message": Mod1,
  "discourse/admin-chat-route-map": Mod2,
  "discourse/chat-route-map": Mod3,
  "discourse/components/browse-channels": Mod4,
  "discourse/components/channel-icon/index": Mod5,
  "discourse/components/channel-name/index": Mod6,
  "discourse/components/channel-title/index": Mod7,
  "discourse/components/channels-list-direct": Mod8,
  "discourse/components/channels-list-public": Mod9,
  "discourse/components/channels-list-starred": Mod10,
  "discourse/components/channels-list": Mod11,
  "discourse/components/chat-channel-archive-status": Mod12,
  "discourse/components/chat-channel-card": Mod13,
  "discourse/components/chat-channel-chooser-header": Mod14,
  "discourse/components/chat-channel-chooser-row": Mod15,
  "discourse/components/chat-channel-chooser": Mod16,
  "discourse/components/chat-channel-filter": Mod17,
  "discourse/components/chat-channel-leave-btn": Mod18,
  "discourse/components/chat-channel-list-filter-menu": Mod19,
  "discourse/components/chat-channel-list-filter-toggle": Mod20,
  "discourse/components/chat-channel-list-options-button": Mod21,
  "discourse/components/chat-channel-list-sidebar-menu": Mod22,
  "discourse/components/chat-channel-list-sort-choice": Mod23,
  "discourse/components/chat-channel-list-sort-menu": Mod24,
  "discourse/components/chat-channel-metadata": Mod25,
  "discourse/components/chat-channel-preview-card": Mod26,
  "discourse/components/chat-channel-row": Mod27,
  "discourse/components/chat-channel-sidebar-context-menu": Mod28,
  "discourse/components/chat-channel-sidebar-context-notification-submenu": Mod29,
  "discourse/components/chat-channel-status": Mod30,
  "discourse/components/chat-channel-title": Mod31,
  "discourse/components/chat-channel-unread-indicator": Mod32,
  "discourse/components/chat-channel": Mod33,
  "discourse/components/chat-composer-dropdown": Mod34,
  "discourse/components/chat-composer-message-details": Mod35,
  "discourse/components/chat-composer-upload": Mod36,
  "discourse/components/chat-composer-uploads": Mod37,
  "discourse/components/chat-composer": Mod38,
  "discourse/components/chat-drawer": Mod39,
  "discourse/components/chat-emoji-avatar": Mod40,
  "discourse/components/chat-footer": Mod41,
  "discourse/components/chat-header": Mod42,
  "discourse/components/chat-mention-warnings": Mod43,
  "discourse/components/chat-message-actions-desktop": Mod44,
  "discourse/components/chat-message-actions-mobile": Mod45,
  "discourse/components/chat-message-collapser": Mod46,
  "discourse/components/chat-message-in-reply-to-indicator": Mod47,
  "discourse/components/chat-message-reaction": Mod48,
  "discourse/components/chat-message-reactions-users": Mod49,
  "discourse/components/chat-message-separator": Mod50,
  "discourse/components/chat-message-text": Mod51,
  "discourse/components/chat-message-thread-indicator": Mod52,
  "discourse/components/chat-message": Mod53,
  "discourse/components/chat-message/blocks/actions": Mod54,
  "discourse/components/chat-message/blocks/block": Mod55,
  "discourse/components/chat-message/blocks/confirmation": Mod56,
  "discourse/components/chat-message/blocks/element": Mod57,
  "discourse/components/chat-message/blocks/elements/button": Mod58,
  "discourse/components/chat-message/blocks/elements/category": Mod59,
  "discourse/components/chat-message/blocks/index": Mod60,
  "discourse/components/chat-message/blocks/informative": Mod61,
  "discourse/components/chat-messages-container": Mod62,
  "discourse/components/chat-messages-scroller": Mod63,
  "discourse/components/chat-notice": Mod64,
  "discourse/components/chat-notices": Mod65,
  "discourse/components/chat-pinned-messages-list": Mod66,
  "discourse/components/chat-replying-indicator": Mod67,
  "discourse/components/chat-retention-reminder-text": Mod68,
  "discourse/components/chat-retention-reminder": Mod69,
  "discourse/components/chat-search": Mod70,
  "discourse/components/chat-side-panel-resizer": Mod71,
  "discourse/components/chat-side-panel": Mod72,
  "discourse/components/chat-sidebar-channel-list-filter-empty-state": Mod73,
  "discourse/components/chat-sidebar-indicators": Mod74,
  "discourse/components/chat-skeleton": Mod75,
  "discourse/components/chat-thread-heading": Mod76,
  "discourse/components/chat-thread-list": Mod77,
  "discourse/components/chat-thread-participants": Mod78,
  "discourse/components/chat-thread-title-prompt": Mod79,
  "discourse/components/chat-thread": Mod80,
  "discourse/components/chat-to-topic-selector": Mod81,
  "discourse/components/chat-upload-drop-zone": Mod82,
  "discourse/components/chat-upload": Mod83,
  "discourse/components/chat-user-avatar": Mod84,
  "discourse/components/chat-user-display-name": Mod85,
  "discourse/components/chat-user-info": Mod86,
  "discourse/components/chat/channel/empty-state": Mod87,
  "discourse/components/chat/composer/button": Mod88,
  "discourse/components/chat/composer/channel": Mod89,
  "discourse/components/chat/composer/separator": Mod90,
  "discourse/components/chat/composer/thread": Mod91,
  "discourse/components/chat/direct-message-button": Mod92,
  "discourse/components/chat/disabled": Mod93,
  "discourse/components/chat/drawer-routes/browse": Mod94,
  "discourse/components/chat/drawer-routes/channel-info-members": Mod95,
  "discourse/components/chat/drawer-routes/channel-info-settings": Mod96,
  "discourse/components/chat/drawer-routes/channel-pins": Mod97,
  "discourse/components/chat/drawer-routes/channel-thread": Mod98,
  "discourse/components/chat/drawer-routes/channel-threads": Mod99,
  "discourse/components/chat/drawer-routes/channel": Mod100,
  "discourse/components/chat/drawer-routes/channels": Mod101,
  "discourse/components/chat/drawer-routes/direct-messages": Mod102,
  "discourse/components/chat/drawer-routes/search": Mod103,
  "discourse/components/chat/drawer-routes/starred-channels": Mod104,
  "discourse/components/chat/drawer-routes/threads": Mod105,
  "discourse/components/chat/footer/unread-indicator": Mod106,
  "discourse/components/chat/form": Mod107,
  "discourse/components/chat/form/row": Mod108,
  "discourse/components/chat/form/section": Mod109,
  "discourse/components/chat/header/icon": Mod110,
  "discourse/components/chat/header/icon/unread-indicator": Mod111,
  "discourse/components/chat/list/empty-state": Mod112,
  "discourse/components/chat/list/index": Mod113,
  "discourse/components/chat/list/item": Mod114,
  "discourse/components/chat/message-creator/add-members": Mod115,
  "discourse/components/chat/message-creator/channel": Mod116,
  "discourse/components/chat/message-creator/constants": Mod117,
  "discourse/components/chat/message-creator/group": Mod118,
  "discourse/components/chat/message-creator/index": Mod119,
  "discourse/components/chat/message-creator/lib/chatables-loader": Mod120,
  "discourse/components/chat/message-creator/lib/iterate-list": Mod121,
  "discourse/components/chat/message-creator/list-action": Mod122,
  "discourse/components/chat/message-creator/list-handler": Mod123,
  "discourse/components/chat/message-creator/list": Mod124,
  "discourse/components/chat/message-creator/member": Mod125,
  "discourse/components/chat/message-creator/members-count": Mod126,
  "discourse/components/chat/message-creator/members-selector": Mod127,
  "discourse/components/chat/message-creator/members": Mod128,
  "discourse/components/chat/message-creator/new-group": Mod129,
  "discourse/components/chat/message-creator/search-input": Mod130,
  "discourse/components/chat/message-creator/search": Mod131,
  "discourse/components/chat/message-creator/user": Mod132,
  "discourse/components/chat/message/avatar": Mod133,
  "discourse/components/chat/message/error": Mod134,
  "discourse/components/chat/message/info": Mod135,
  "discourse/components/chat/message/left-gutter": Mod136,
  "discourse/components/chat/modal/archive-channel": Mod137,
  "discourse/components/chat/modal/create-channel": Mod138,
  "discourse/components/chat/modal/delete-channel": Mod139,
  "discourse/components/chat/modal/delete-messages-confirm": Mod140,
  "discourse/components/chat/modal/edit-channel-description": Mod141,
  "discourse/components/chat/modal/edit-channel-name": Mod142,
  "discourse/components/chat/modal/move-message-to-channel": Mod143,
  "discourse/components/chat/modal/new-message": Mod144,
  "discourse/components/chat/modal/thread-settings": Mod145,
  "discourse/components/chat/modal/toggle-channel-status": Mod146,
  "discourse/components/chat/navbar/actions": Mod147,
  "discourse/components/chat/navbar/back-button": Mod148,
  "discourse/components/chat/navbar/channel-list-options-button": Mod149,
  "discourse/components/chat/navbar/channel-title": Mod150,
  "discourse/components/chat/navbar/close-drawer-button": Mod151,
  "discourse/components/chat/navbar/close-pins-button": Mod152,
  "discourse/components/chat/navbar/close-thread-button": Mod153,
  "discourse/components/chat/navbar/close-threads-button": Mod154,
  "discourse/components/chat/navbar/filter": Mod155,
  "discourse/components/chat/navbar/full-page-button": Mod156,
  "discourse/components/chat/navbar/index": Mod157,
  "discourse/components/chat/navbar/new-channel-button": Mod158,
  "discourse/components/chat/navbar/open-drawer-button": Mod159,
  "discourse/components/chat/navbar/pinned-messages-button": Mod160,
  "discourse/components/chat/navbar/sub-title": Mod161,
  "discourse/components/chat/navbar/thread-settings-button": Mod162,
  "discourse/components/chat/navbar/thread-tracking-dropdown": Mod163,
  "discourse/components/chat/navbar/threads-list-button": Mod164,
  "discourse/components/chat/navbar/title": Mod165,
  "discourse/components/chat/navbar/toggle-drawer-button": Mod166,
  "discourse/components/chat/notices/mention_without_membership": Mod167,
  "discourse/components/chat/pinned-message-bar": Mod168,
  "discourse/components/chat/pinned-messages-list/header": Mod169,
  "discourse/components/chat/routes/channel-info-members": Mod170,
  "discourse/components/chat/routes/channel-info-nav": Mod171,
  "discourse/components/chat/routes/channel-info-settings": Mod172,
  "discourse/components/chat/routes/channel-info": Mod173,
  "discourse/components/chat/routes/channel-pins": Mod174,
  "discourse/components/chat/routes/channel-thread": Mod175,
  "discourse/components/chat/routes/channel-threads": Mod176,
  "discourse/components/chat/routes/channel": Mod177,
  "discourse/components/chat/routes/channels": Mod178,
  "discourse/components/chat/routes/direct-messages": Mod179,
  "discourse/components/chat/routes/search": Mod180,
  "discourse/components/chat/routes/starred-channels": Mod181,
  "discourse/components/chat/routes/threads": Mod182,
  "discourse/components/chat/scroll-to-bottom-arrow": Mod183,
  "discourse/components/chat/selection-manager": Mod184,
  "discourse/components/chat/thread-list/header": Mod185,
  "discourse/components/chat/thread-list/item": Mod186,
  "discourse/components/chat/thread/header-unread-indicator": Mod187,
  "discourse/components/chat/thread/header": Mod188,
  "discourse/components/collapser": Mod189,
  "discourse/components/full-page-chat": Mod190,
  "discourse/components/reviewable/chat-message": Mod191,
  "discourse/components/styleguide/chat-composer-message-details": Mod192,
  "discourse/components/styleguide/chat-composer": Mod193,
  "discourse/components/styleguide/chat-header-icon": Mod194,
  "discourse/components/styleguide/chat-message": Mod195,
  "discourse/components/styleguide/chat-modal-archive-channel": Mod196,
  "discourse/components/styleguide/chat-modal-create-channel": Mod197,
  "discourse/components/styleguide/chat-modal-delete-channel": Mod198,
  "discourse/components/styleguide/chat-modal-edit-channel-description": Mod199,
  "discourse/components/styleguide/chat-modal-edit-channel-name": Mod200,
  "discourse/components/styleguide/chat-modal-move-message-to-channel": Mod201,
  "discourse/components/styleguide/chat-modal-new-message": Mod202,
  "discourse/components/styleguide/chat-modal-thread-settings": Mod203,
  "discourse/components/styleguide/chat-modal-toggle-channel-status": Mod204,
  "discourse/components/styleguide/chat-thread-list-item": Mod205,
  "discourse/components/styleguide/organisms/chat": Mod206,
  "discourse/components/svg/chat-zero": Mod207,
  "discourse/components/thread-notifications-tracking": Mod208,
  "discourse/components/thread-title/index": Mod209,
  "discourse/components/thread-unread-indicator/index": Mod210,
  "discourse/components/toggle-channel-membership-button": Mod211,
  "discourse/components/upsert-category/chat": Mod212,
  "discourse/components/user-menu/chat-notifications-list-empty-state": Mod213,
  "discourse/components/user-menu/chat-notifications-list": Mod214,
  "discourse/components/user-threads/index": Mod215,
  "discourse/components/user-threads/preview": Mod216,
  "discourse/connectors/above-site-header/chat-body-class": Mod217,
  "discourse/connectors/below-footer/chat-drawer-outlet": Mod218,
  "discourse/connectors/chat-composer-inline-buttons/emoji-picker": Mod219,
  "discourse/connectors/home-logo-wrapper/chat-header-connector": Mod220,
  "discourse/connectors/user-card-below-message-button/chat-button": Mod221,
  "discourse/connectors/user-preferences-emails-pref-email-settings/preferences-chat-emails": Mod222,
  "discourse/connectors/user-preferences-nav/chat-preferences": Mod223,
  "discourse/connectors/user-preferences-notifications/chat-notifications": Mod224,
  "discourse/connectors/user-profile-controls/chat-button": Mod225,
  "discourse/controllers/chat-draft-channel": Mod226,
  "discourse/controllers/chat": Mod227,
  "discourse/controllers/chat/channel": Mod228,
  "discourse/controllers/chat/channel/index": Mod229,
  "discourse/controllers/chat/channel/thread": Mod230,
  "discourse/controllers/chat/index": Mod231,
  "discourse/controllers/chat/new-message": Mod232,
  "discourse/helpers/chat-guardian": Mod233,
  "discourse/helpers/first-visible-message-id": Mod234,
  "discourse/helpers/format-chat-date": Mod235,
  "discourse/initializers/chat-audio": Mod236,
  "discourse/initializers/chat-category-tab": Mod237,
  "discourse/initializers/chat-decorators": Mod238,
  "discourse/initializers/chat-keyboard-shortcuts": Mod239,
  "discourse/initializers/chat-plugin-decorators": Mod240,
  "discourse/initializers/chat-setup": Mod241,
  "discourse/initializers/chat-sidebar": Mod242,
  "discourse/initializers/chat-user-menu": Mod243,
  "discourse/initializers/chat-user-options": Mod244,
  "discourse/lib/chat-alert-dedup": Mod245,
  "discourse/lib/chat-channel-list-options": Mod246,
  "discourse/lib/chat-channel-subscription-manager": Mod247,
  "discourse/lib/chat-channel-thread-subscription-manager": Mod248,
  "discourse/lib/chat-composer-buttons": Mod249,
  "discourse/lib/chat-constants": Mod250,
  "discourse/lib/chat-message-announcement": Mod251,
  "discourse/lib/chat-message-container": Mod252,
  "discourse/lib/chat-message-flag": Mod253,
  "discourse/lib/chat-message-interactor": Mod254,
  "discourse/lib/chat-messages-loader": Mod255,
  "discourse/lib/chat-messages-manager": Mod256,
  "discourse/lib/chat-notification-levels": Mod257,
  "discourse/lib/chat-pane-state": Mod258,
  "discourse/lib/chat-pinned-bar-dismissal": Mod259,
  "discourse/lib/chat-threads-manager": Mod260,
  "discourse/lib/chat-user-preferences": Mod261,
  "discourse/lib/check-message-visibility": Mod262,
  "discourse/lib/collection": Mod263,
  "discourse/lib/dates-separators-positioner": Mod264,
  "discourse/lib/extract-current-topic-info": Mod265,
  "discourse/lib/fabricators": Mod266,
  "discourse/lib/get-reaction-text": Mod267,
  "discourse/lib/get-user-chat-separate-sidebar-mode": Mod268,
  "discourse/lib/gif-pick-handler": Mod269,
  "discourse/lib/group-chat-transcripts": Mod270,
  "discourse/lib/hashtag-types/channel": Mod271,
  "discourse/lib/init-sidebar-state": Mod272,
  "discourse/lib/scroll-helpers": Mod273,
  "discourse/lib/slugify-channel": Mod274,
  "discourse/lib/textarea-interactor": Mod275,
  "discourse/lib/transcript-source-types": Mod276,
  "discourse/lib/transform-auto-links": Mod277,
  "discourse/models/chat-channel-archive": Mod278,
  "discourse/models/chat-channel": Mod279,
  "discourse/models/chat-chatable": Mod280,
  "discourse/models/chat-direct-message": Mod281,
  "discourse/models/chat-message-reaction": Mod282,
  "discourse/models/chat-message": Mod283,
  "discourse/models/chat-notice": Mod284,
  "discourse/models/chat-thread-preview": Mod285,
  "discourse/models/chat-thread": Mod286,
  "discourse/models/chat-tracking-state": Mod287,
  "discourse/models/user-chat-channel-membership": Mod288,
  "discourse/models/user-chat-thread-membership": Mod289,
  "discourse/modifiers/chat/later-fn": Mod290,
  "discourse/modifiers/chat/on-animation-end": Mod291,
  "discourse/modifiers/chat/on-long-press": Mod292,
  "discourse/modifiers/chat/on-scroll": Mod293,
  "discourse/modifiers/chat/resizable-node": Mod294,
  "discourse/modifiers/chat/scrollable-list": Mod295,
  "discourse/modifiers/chat/track-message-separator-date": Mod296,
  "discourse/modifiers/chat/track-message": Mod297,
  "discourse/pre-initializers/chat-plugin-api": Mod298,
  "discourse/pre-initializers/chat-transformers": Mod299,
  "discourse/preferences-chat-route-map": Mod300,
  "discourse/routes/chat-channel-decorator": Mod301,
  "discourse/routes/chat-channel-legacy": Mod302,
  "discourse/routes/chat-draft-channel": Mod303,
  "discourse/routes/chat": Mod304,
  "discourse/routes/chat/browse": Mod305,
  "discourse/routes/chat/browse/archived": Mod306,
  "discourse/routes/chat/browse/index": Mod307,
  "discourse/routes/chat/channel": Mod308,
  "discourse/routes/chat/channel/info": Mod309,
  "discourse/routes/chat/channel/info/index": Mod310,
  "discourse/routes/chat/channel/info/members": Mod311,
  "discourse/routes/chat/channel/info/search": Mod312,
  "discourse/routes/chat/channel/near-message-with-thread": Mod313,
  "discourse/routes/chat/channel/near-message": Mod314,
  "discourse/routes/chat/channel/pins": Mod315,
  "discourse/routes/chat/channel/thread": Mod316,
  "discourse/routes/chat/channel/thread/near-message": Mod317,
  "discourse/routes/chat/channel/threads": Mod318,
  "discourse/routes/chat/channels": Mod319,
  "discourse/routes/chat/direct-messages": Mod320,
  "discourse/routes/chat/disabled": Mod321,
  "discourse/routes/chat/index": Mod322,
  "discourse/routes/chat/new-message": Mod323,
  "discourse/routes/chat/search": Mod324,
  "discourse/routes/chat/starred-channels": Mod325,
  "discourse/routes/chat/threads": Mod326,
  "discourse/routes/preferences/chat": Mod327,
  "discourse/services/chat-admin-api": Mod328,
  "discourse/services/chat-api": Mod329,
  "discourse/services/chat-audio-manager": Mod330,
  "discourse/services/chat-channel-composer": Mod331,
  "discourse/services/chat-channel-info-route-origin-manager": Mod332,
  "discourse/services/chat-channel-list-preferences": Mod333,
  "discourse/services/chat-channel-notices-manager": Mod334,
  "discourse/services/chat-channel-pane": Mod335,
  "discourse/services/chat-channel-scroll-positions": Mod336,
  "discourse/services/chat-channels-manager": Mod337,
  "discourse/services/chat-composer-warnings-tracker": Mod338,
  "discourse/services/chat-drafts-manager": Mod339,
  "discourse/services/chat-drawer-router": Mod340,
  "discourse/services/chat-drawer-size": Mod341,
  "discourse/services/chat-guardian": Mod342,
  "discourse/services/chat-history": Mod343,
  "discourse/services/chat-new-message-announcer": Mod344,
  "discourse/services/chat-notification-manager": Mod345,
  "discourse/services/chat-pane-pending-manager": Mod346,
  "discourse/services/chat-search-query": Mod347,
  "discourse/services/chat-state-manager": Mod348,
  "discourse/services/chat-subscriptions-manager": Mod349,
  "discourse/services/chat-thread-composer": Mod350,
  "discourse/services/chat-thread-list-pane": Mod351,
  "discourse/services/chat-thread-pane": Mod352,
  "discourse/services/chat-tracking-state-manager": Mod353,
  "discourse/services/chat": Mod354,
  "discourse/services/interacted-chat-message": Mod355,
  "discourse/templates/chat": Mod356,
  "discourse/templates/chat/browse": Mod357,
  "discourse/templates/chat/browse/all": Mod358,
  "discourse/templates/chat/browse/archived": Mod359,
  "discourse/templates/chat/browse/closed": Mod360,
  "discourse/templates/chat/browse/open": Mod361,
  "discourse/templates/chat/channel": Mod362,
  "discourse/templates/chat/channel/info": Mod363,
  "discourse/templates/chat/channel/info/members": Mod364,
  "discourse/templates/chat/channel/info/settings": Mod365,
  "discourse/templates/chat/channel/pins": Mod366,
  "discourse/templates/chat/channel/thread": Mod367,
  "discourse/templates/chat/channel/threads": Mod368,
  "discourse/templates/chat/channels": Mod369,
  "discourse/templates/chat/direct-messages": Mod370,
  "discourse/templates/chat/disabled": Mod371,
  "discourse/templates/chat/index": Mod372,
  "discourse/templates/chat/search": Mod373,
  "discourse/templates/chat/starred-channels": Mod374,
  "discourse/templates/chat/threads": Mod375,
  "discourse/templates/preferences/chat": Mod376,
  "lib/discourse-markdown/chat-html-inline": Mod377,
  "lib/discourse-markdown/chat-transcript": Mod378,
  "lib/rich-editor-extension": Mod379,
};
export { compatModules };
export default compatModules;
